import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';
import type { LPAccountsResultDto } from '@/api/types/lpAccounts';

// LP Accounts live hub (/hubs/lp-accounts-live). Calls Subscribe() on connect (no
// args) and receives OnLPAccountsReceived(LPAccountsResultDto). Mirrors
// LPAccountsTab/index.js.
export function useLpAccountsLive({
  enabled,
  onData,
  onError,
}: {
  enabled: boolean;
  onData: (data: LPAccountsResultDto) => void;
  onError?: (message: string) => void;
}): { status: ConnectionStatus } {
  const { status } = useSignalRHub({
    url: '/hubs/lp-accounts-live',
    enabled,
    on: {
      OnLPAccountsReceived: (data) => onData(data as LPAccountsResultDto),
      OnLPAccountsError: (message) => onError?.(String(message ?? 'LP accounts live update failed.')),
    },
    onConnected: (conn) => {
      void conn.invoke('Subscribe').catch(() => onError?.('Failed to connect to live LP accounts.'));
    },
  });
  return { status };
}
